import { render, staticRenderFns } from "./CorporaStats.vue?vue&type=template&id=00443d75&scoped=true&"
import script from "./CorporaStats.vue?vue&type=script&lang=js&"
export * from "./CorporaStats.vue?vue&type=script&lang=js&"
import style0 from "./CorporaStats.vue?vue&type=style&index=0&id=00443d75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00443d75",
  null
  
)

component.options.__file = "CorporaStats.vue"
export default component.exports